import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from './material/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { ToastrModule } from 'ngx-toastr';
import { HttpClientModule } from '@angular/common/http';
import { RechercheModule } from '@unilog/recherche';
import { UnilogNg9TableModule } from '@unilog/ng9-table';
import { DocumentsComponent } from './documents/documents.component';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { CommentSectionComponent } from './documents/comment-section/comment-section.component';
import { FlatDocumentComponent } from './documents/flat-document/flat-document.component';
import { FileDetailsDialogComponent } from './documents/file-details-dialog/file-details-dialog.component';


@NgModule({
  declarations: [
    DocumentsComponent,
    CommentSectionComponent,
    FlatDocumentComponent,
    FileDetailsDialogComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    ToastrModule.forRoot(),
    HttpClientModule,
    RechercheModule,
    UnilogNg9TableModule,
    MaterialModule,
    AngularEditorModule
  ],
  exports: [
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    ToastrModule,
    RechercheModule,
    UnilogNg9TableModule,
    DocumentsComponent,
    HttpClientModule,
    AngularEditorModule,
    CommentSectionComponent,
    FlatDocumentComponent
  ]
})
export class SharedModule { }
